import { JSON } from '@symon-ai/wisepipe-serialize';
export function encodeToken(contToken) {
    // For table could be multiple tokens
    if (!contToken.token && !contToken.tokenV2)
        return undefined;
    return encodeURIComponent(JSON.stringify(contToken));
}
export function decodeToken(token) {
    return JSON.parse(decodeURIComponent(token));
}
//# sourceMappingURL=continuationToken.js.map